export const GTM_CAPTURE_BANNER_VIEWPORT_CLASS_NAME = 'gtm-bnr-comp-evt-enbld';

export const GTM_BANNER_COMPONENT_POSITION_CLASS_NAME = 'gtm-bnr-comp-postn-';

export const plpSourceDetails = {
  trendingcategories: 'trending categories',
  historySearch: 'history search',
  userCompletedSearch: 'user completed search',
  autoSuggestionSearch: 'auto suggestion search'
};
